module.exports = __webpack_public_path__ + "img/icon-impediment.0ca2d117.svg";